import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Product } from 'src/app/models/interface/product/product';
import { FtthService } from 'src/app/services/api/ftth/ftth.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductDepthLevelProductActionsComponent } from '../product-depth-level-product-actions.component';
import {AppService} from 'src/app/app.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.scss']
})
export class ActivateComponent implements OnInit {

  activateGroup: FormGroup;

  item: Product;
  loading: boolean;
  ispVF: boolean;
  isCoorporate: boolean;

  private subscriptions = new Subscription();

  constructor(
    private ftthService: FtthService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private dialogRef: MatDialogRef<ProductDepthLevelProductActionsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      item: Product;
      type: string;
    },
    private appService: AppService,
    private formBuilder: FormBuilder,
  ) {

  }

  ngOnInit() {
    this.loading = false;
    this.item = this.data.item;
    this.ispVF = this.appService.settings.ispVF === this.item.productCharValues.find(charValue => charValue.specId === 'pc_ftth_territory_user').value;
    this.isCoorporate = this.appService.settings.productCorporate === this.item.productCharValues.find(charValue => charValue.specId === "pc_ftth_client_segment").value;

    if (this.data.type !== 'product') {
      throw new Error('It must be a product');
    }

    this.initForm();
  }

  private initForm() {
      this.activateGroup = this.formBuilder.group({
        cvlan1: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        cvlan2: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        cvlan3: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        cvlan4: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        cvlan5: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        avlan1: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        avlan2: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        avlan3: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        avlan4: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        avlan5: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
        svlan: this.formBuilder.control({ value: '', disabled: false }, Validators.required),
      });
    }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  activate(){
    this.loading = true;

    if (this.item.productCharValues.find(charValue => charValue.specId === "pc_ftth_client_segment").value === this.appService.settings.productCorporate) {
      if(this.item.productCharValues.find(charValue => charValue.specId === "pc_ftth_territory_user").value === this.appService.settings.ispVF){
        this.activateEnterpriseVfProduct();
      }
      else{
        this.activateEnterpriseProduct();
      }
    }
    else {
      this.activateProduct();
    }
  }

  activateProduct() {
    this.ftthService.activation({
      'operador': this.item.origin,
      'idadministrativo': this.item.productCharValues.find(charValue => charValue.specId === "pc_ftth_service_id").value,
      'onu': '',
      'password': ''
    })
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.resultado !== 'NOK' && data.resultado !== 'KO') {
            this.dialogRef.close(true);
            this.notificationsService.showNotification(this.translateService.instant('ACTIVATE_PRODUCT.success'), NotificationLevel.SUCCESS);
          }
          else {
            this.notificationsService.showNotification("ERROR (" + data.codResultado + "): " + data.descResultado, NotificationLevel.ERROR);
          }
        },
        error => {
          this.loading = false;
          this.notificationsService.showNotification("ERROR (" + error.data.codResultado + "): " + error.data.descResultado, NotificationLevel.ERROR);
        }
      );
  }

  activateEnterpriseProduct(){
    if(this.validateForm()){
      this.ftthService.activationEnterprise({
        'operador': this.item.origin,
        'idadministrativo': this.item.productCharValues.find(charValue => charValue.specId === "pc_ftth_service_id").value,
        'onu': '',
        'password': '',
        'cvlan1': this.cvlan1Control.value,
        'cvlan2': this.cvlan2Control.value,
        'cvlan3': this.cvlan3Control.value,
        'cvlan4': this.cvlan4Control.value,
        'cvlan5': this.cvlan5Control.value,
        'avlan1': this.avlan1Control.value,
        'avlan2': this.avlan2Control.value,
        'avlan3': this.avlan3Control.value,
        'avlan4': this.avlan4Control.value,
        'avlan5': this.avlan5Control.value,
        'svlan': this.svlanControl.value
      })
        .subscribe(
          (data) => {
            this.loading = false;
            if (data && data.resultado !== 'NOK' && data.resultado !== 'KO') {
              this.dialogRef.close(true);
              this.notificationsService.showNotification(this.translateService.instant('ACTIVATE_PRODUCT.success'), NotificationLevel.SUCCESS);
            }
            else {
              this.notificationsService.showNotification("ERROR (" + data.codResultado + "): " + data.descResultado, NotificationLevel.ERROR);
            }
          },
          error => {
            this.loading = false;
            this.notificationsService.showNotification("ERROR (" + error.data.codResultado + "): " + error.data.descResultado, NotificationLevel.ERROR);
          }
        );
    }
    else{
      this.loading = false;
    }
  }

  activateEnterpriseVfProduct(){
    if(this.validateFormEnterpriseVf()){
      this.ftthService.activationEnterpriseVf({
        'operador': this.item.origin,
        'idadministrativo': this.item.productCharValues.find(charValue => charValue.specId === "pc_ftth_service_id").value,
        'onu': '',
        'password': '',
        'cvlan1': this.cvlan1Control.value,
        'cvlan2': this.cvlan2Control.value,
        'cvlan3': this.cvlan3Control.value,
        'cvlan4': this.cvlan4Control.value,
        'cvlan5': this.cvlan5Control.value,
      })
        .subscribe(
          (data) => {
            this.loading = false;
            if (data && data.resultado !== 'NOK' && data.resultado !== 'KO') {
              this.dialogRef.close(true);
              this.notificationsService.showNotification(this.translateService.instant('ACTIVATE_PRODUCT.success'), NotificationLevel.SUCCESS);
            }
            else {
              this.notificationsService.showNotification("ERROR (" + data.codResultado + "): " + data.descResultado, NotificationLevel.ERROR);
            }
          },
          error => {
            this.loading = false;
            this.notificationsService.showNotification("ERROR (" + error.data.codResultado + "): " + error.data.descResultado, NotificationLevel.ERROR);
          }
        );
    }
    else{
      this.loading = false;
    }
  }

  validateFormEnterpriseVf(): boolean{
    if(this.cvlan1Control.value === '' || this.cvlan2Control.value === '' || this.cvlan3Control.value === '' ||
    this.cvlan4Control.value === '' || this.cvlan5Control.value === ''){
      this.notificationsService.showNotification("ERROR (Es necesario cubrir los campos del formulario marcados como obligatorios.)", NotificationLevel.ERROR);
      return false;
    }
    return true;
  }

  validateForm(): boolean{
      if(!this.activateGroup.valid){
        this.notificationsService.showNotification("ERROR (Es necesario cubrir los campos del formulario marcados como obligatorios.)", NotificationLevel.ERROR);
        return false;
      }
      return true;
    }

  get cvlan1Control(): FormControl {
    return this.activateGroup.get('cvlan1') as FormControl;
  }

  get cvlan2Control(): FormControl {
    return this.activateGroup.get('cvlan2') as FormControl;
  }

  get cvlan3Control(): FormControl {
    return this.activateGroup.get('cvlan3') as FormControl;
  }

  get cvlan4Control(): FormControl {
    return this.activateGroup.get('cvlan4') as FormControl;
  }

  get cvlan5Control(): FormControl {
    return this.activateGroup.get('cvlan5') as FormControl;
  }
  get avlan1Control(): FormControl {
    return this.activateGroup.get('avlan1') as FormControl;
  }

  get avlan2Control(): FormControl {
    return this.activateGroup.get('avlan2') as FormControl;
  }

  get avlan3Control(): FormControl {
    return this.activateGroup.get('avlan3') as FormControl;
  }

  get avlan4Control(): FormControl {
    return this.activateGroup.get('avlan4') as FormControl;
  }

  get avlan5Control(): FormControl {
    return this.activateGroup.get('avlan5') as FormControl;
  }

  get svlanControl(): FormControl {
      return this.activateGroup.get('svlan') as FormControl;
    }

}
